import React from "react"
import Link from "../../link"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebook as fabFacebook } from "@fortawesome/free-brands-svg-icons"
import { faTwitter as fabTwitter } from "@fortawesome/free-brands-svg-icons"
import { faLinkedinIn as fabLinkedinIn } from "@fortawesome/free-brands-svg-icons"
import FooterLogo from "../../../static/assets/images/logo-with-text-vertical.png"
import { useLocation } from "@reach/router"
import "./footer.css"
import { FormattedMessage, useIntl } from "react-intl"
import LanguageSwitcher from "../language-switcher/LanguageSwitcher"
import { isFooterVisible } from "../layout/header-footer-visibility"
import { socialProfiles } from "../../site-constants"
import { WingsHeading, WingsLink } from "@wingspans-ui"
import { publicPageGroups } from "../home-page/publicPages"
import useIsMainSite from "../hooks/useIsMainSite"
import "../../global-styles/home-style-overrides.css"

const Footer = () => {
  const { formatMessage } = useIntl()
  const location = useLocation()
  const localizationEnabled = process.env.GATSBY_ENABLE_LOCALIZATION === "true"

  const isMainSite = useIsMainSite()

  const isVisible = isFooterVisible(location?.pathname)

  return (
    <>
      {isVisible && (
        <footer className="public-footer printer-none">
          <div className="inner inner-footer">
            <div className="public-footer-primary">
              <span className="logo">
                <Link to="/">
                  <img
                    className="logo-image"
                    src={FooterLogo}
                    alt="Wingspans"
                  />
                </Link>
              </span>

              <nav className="navigation" aria-label={formatMessage({ id: "footer-nav-label", defaultMessage: "Footer" })}>
                <ul className="menu-secondary menu-secondary-level-0">
                  {publicPageGroups
                    .filter((group) => isMainSite || !group.hideInPrivateFooter)
                    .map((group) => (
                      <li key={group.key}>
                        <WingsHeading level={6} className="footer-nav-heading" id={`footer-nav-heading-${group.key}`}>
                          <FormattedMessage {...group.titleMessage} />
                        </WingsHeading>
                        <ul className="menu-secondary menu-secondary-level-1" aria-labelledby={`footer-nav-heading-${group.key}`}>
                          {group.pages.map((page) => (
                            <li key={page.key}>
                              <WingsLink to={page.path} size="detail" className="footer-nav-link">
                                <FormattedMessage {...page.titleMessage} />
                              </WingsLink>
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  <li>
                    <WingsHeading level={6} className="footer-nav-heading" id="footer-nav-heading-support">
                      <FormattedMessage id="footer-support" defaultMessage="Support" />
                    </WingsHeading>
                    <ul className="menu-secondary menu-secondary-level-1" aria-labelledby="footer-nav-heading-support">
                      <li>
                        <WingsLink to="/contact" size="detail" className="footer-nav-link">
                          <FormattedMessage id="footer-contact" defaultMessage="Contact" />
                        </WingsLink>
                      </li>
                      <li>
                        <WingsLink to="/about/privacy-policy" size="detail" className="footer-nav-link">
                          <FormattedMessage id="footer-privacy-policy" defaultMessage="Privacy Policy" />
                        </WingsLink>
                      </li>
                      <li>
                        <WingsLink to="/about/terms-of-use" size="detail" className="footer-nav-link">
                          <FormattedMessage id="footer-terms-of-use" defaultMessage="Terms of Use" />
                        </WingsLink>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>

              <ul className="social-links">
                <li>
                  <a aria-label="LinkedIn" href={socialProfiles.linkedin} data-gtm="footer-social-linkedin">
                    <FontAwesomeIcon icon={fabLinkedinIn} />
                  </a>
                </li>
                <li>
                  <a aria-label="X (Twitter)" href={socialProfiles.twitter} data-gtm="footer-social-twitter">
                    <FontAwesomeIcon icon={fabTwitter} />
                  </a>
                </li>
                <li>
                  <a aria-label="Facebook" href={socialProfiles.facebook} data-gtm="footer-social-facebook">
                    <FontAwesomeIcon icon={fabFacebook} />
                  </a>
                </li>
              </ul>
            </div>

            <div className="public-footer-language-switcher">
              <div className="footer-utility-row">
                <div className="footer-language-switcher-control">{localizationEnabled && <LanguageSwitcher footer={true} />}</div>
              </div>
              <div className="copyright">&copy; <FormattedMessage
                id="footer-copyright"
                defaultMessage="Copyright"
              />  {new Date().getFullYear()} Wingspans</div>
            </div>
          </div>
        </footer>
      )}
    </>
  )
}

export default Footer
